function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgChatbox = function SvgChatbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 21555",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17745",
    d: "M16 10h-.01M12 10h-.01M8 10h-.01M15 16h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h5l5 5z",
    transform: "translate(.333 -.667)",
    style: {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 19935",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }));
};

export default SvgChatbox;